import ResponsiveUtilities from './responsive-utilities';
const init = () => {
  let minHeight = 0;
  const $containers = jQuery('[data-dynamic-min-height]');

  $containers.each(function (index, element) {
    const $element = jQuery(element);
    ResponsiveUtilities.onDeviceType(['tablet', 'desktop'], function () {
      minHeight = Math.max(minHeight, $element.outerHeight());
    }, this);
  });

  $containers.css(`min-height`, `${minHeight}px`);
};

export default { init };
